import { useEffect, useState } from 'react';
import { getProductionCalendarYearList } from 'services/api';
import type { CalendarListData } from './types';
import { transformCalendarDataToListData } from '../lib';

interface UseCalendarListServiceProps {
  calendarYear: string;
  refreshTrigger: number;
}

export const useCalendarListService = ({
  calendarYear,
  refreshTrigger,
}: UseCalendarListServiceProps) => {
  const [loading, setLoading] = useState(false);
  const [dates, setDates] = useState<CalendarListData[]>([]);

  const getCalendarYearList = async () => {
    setLoading(true);
    await getProductionCalendarYearList(calendarYear)
      .then((res) => {
        setDates(transformCalendarDataToListData(res));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (calendarYear) {
      getCalendarYearList();
    }
  }, [calendarYear, refreshTrigger]);

  return { state: { loading, listData: dates } };
};
